const router = [
  {
    path: '/ele/bill',
    name: 'EleBill',
    component: () => import('@/views/ele-bill/EleBill.vue'),
    meta: {
      title: '电子结算单',
      checkToken: false
    }
  }
];
export default router;
